import { CalculateFestivalCo2 } from '@/domain/impact-calculate-festival/entities/calculate-festival-co2.entity';
import { References } from '@/domain/impact-references/entities/references.entity';
import { translate } from '@/ui/i18n';
import { ProjectScoresDetailsData } from '@/ui/pages/app/components/project-page/ProjectScoresDetails/ProjectScoresDetails.types';

export function prepareProjectFestivalScoreDetailsDataCo2(
  calculateCo2: CalculateFestivalCo2,
  references: References,
): ProjectScoresDetailsData[] {
  return [
    {
      title: translate('Projects.team'),
      value: calculateCo2.sectors.team.score,
      maxValue: NaN,
      refValue: references.sectors.team.co2.score,
      labels: {
        value: translate('Projects.teCO2'),
        refValue: translate('Projects.ref-value'),
      },
      infos: {
        value: translate('Projects.infos-score-detail-card.co2-value'),
        refValue: translate('Projects.infos-score-detail-card.ref-value'),
      },
      viewMode: 'bar',
      sector: 'TEAM',
      detailsValues: [
        {
          name: translate('Co2.Sections.MOBILITY'),
          value: calculateCo2.sectors.team.categories.mobility.score,
          unit: translate('Projects.teCO2'),
          topic: 'mobility',
          type: 'co2',
          section: '',
        },
        {
          name: translate('Co2.Sections.CATERING'),
          value: calculateCo2.sectors.team.categories.catering.score,
          unit: translate('Projects.teCO2'),
          topic: 'catering',
          type: 'co2',
          section: '',
        },
        {
          name: translate('Co2.Sections.ACCOMMODATION'),
          value: calculateCo2.sectors.team.categories.accommodation.score,
          unit: translate('Projects.teCO2'),
          topic: 'accommodation',
          type: 'co2',
          section: '',
        },
      ],
    },
    {
      title: translate('Projects.artists'),
      value: calculateCo2.sectors.artists.score,
      maxValue: NaN,
      refValue: references.sectors.artists.co2.score,
      labels: {
        value: translate('Projects.teCO2'),
        refValue: translate('Projects.ref-value'),
      },
      infos: {
        value: translate('Projects.infos-score-detail-card.co2-value'),
        refValue: translate('Projects.infos-score-detail-card.ref-value'),
      },
      viewMode: 'bar',
      sector: 'ARTISTS',
      detailsValues: [
        {
          name: translate('Co2.Sections.MOBILITY'),
          value: calculateCo2.sectors.artists.categories.mobility.score,
          unit: translate('Projects.teCO2'),
          topic: 'mobility',
          type: 'co2',
          section: '',
        },
        {
          name: translate('Co2.Sections.CATERING'),
          value: calculateCo2.sectors.artists.categories.catering.score,
          unit: translate('Projects.teCO2'),
          topic: 'catering',
          type: 'co2',
          section: '',
        },
        {
          name: translate('Co2.Sections.ACCOMMODATION'),
          value: calculateCo2.sectors.artists.categories.accommodation.score,
          unit: translate('Projects.teCO2'),
          topic: 'accommodation',
          type: 'co2',
          section: '',
        },
        {
          name: translate('Co2.Sections.CARGO'),
          value: calculateCo2.sectors.artists.categories.cargo.score,
          unit: translate('Projects.teCO2'),
          topic: 'cargo',
          type: 'co2',
          section: '',
        },
      ],
    },
    {
      title: translate('Projects.public'),
      value: calculateCo2.sectors.public.score,
      maxValue: NaN,
      refValue: references.sectors.public.co2.score,
      labels: {
        value: translate('Projects.teCO2'),
        refValue: translate('Projects.ref-value'),
      },
      infos: {
        value: translate('Projects.infos-score-detail-card.co2-value'),
        refValue: translate('Projects.infos-score-detail-card.ref-value'),
      },
      viewMode: 'bar',
      sector: 'PUBLIC',
      detailsValues: [
        {
          name: translate('Co2.Sections.MOBILITY'),
          value: calculateCo2.sectors.public.categories.mobility.score,
          unit: translate('Projects.teCO2'),
          topic: 'mobility',
          type: 'co2',
          section: '',
        },
        {
          name: translate('Co2.Sections.CATERING'),
          value: calculateCo2.sectors.public.categories.catering.score,
          unit: translate('Projects.teCO2'),
          topic: 'catering',
          type: 'co2',
          section: '',
        },
        {
          name: translate('Co2.Sections.ACCOMMODATION'),
          value: calculateCo2.sectors.public.categories.accommodation.score,
          unit: translate('Projects.teCO2'),
          topic: 'accommodation',
          type: 'co2',
          section: '',
        },
        {
          name: translate('Co2.Sections.DIGITAL'),
          value: calculateCo2.sectors.public.categories.digital.score,
          unit: translate('Projects.teCO2'),
          topic: 'digital',
          type: 'co2',
          section: '',
        },
      ],
    },
    {
      title: translate('Projects.site'),
      value: calculateCo2.sectors.site.score,
      maxValue: NaN,
      refValue: references.sectors.site.co2.score,
      labels: {
        value: translate('Projects.teCO2'),
        refValue: translate('Projects.ref-value'),
      },
      infos: {
        value: translate('Projects.infos-score-detail-card.co2-value'),
        refValue: translate('Projects.infos-score-detail-card.ref-value'),
      },
      viewMode: 'bar',
      sector: 'SITE',
      detailsValues: [
        {
          name: translate('Co2.Sections.ENERGY'),
          value: calculateCo2.sectors.site.categories.energy.score,
          unit: translate('Projects.teCO2'),
          topic: 'energy',
          type: 'co2',
          section: '',
        },
        {
          name: translate('Co2.Sections.WATER'),
          value: calculateCo2.sectors.site.categories.water.score,
          unit: translate('Projects.teCO2'),
          topic: 'water',
          type: 'co2',
          section: '',
        },
        {
          name: translate('Co2.Sections.WASTE'),
          value: calculateCo2.sectors.site.categories.waste.score,
          unit: translate('Projects.teCO2'),
          topic: 'waste',
          type: 'co2',
          section: '',
        },
        {
          name: translate('Co2.Sections.EQUIPMENT'),
          value: calculateCo2.sectors.site.categories.equipment.score,
          unit: translate('Projects.teCO2'),
          topic: 'equipment',
          type: 'co2',
          section: '',
        },
        {
          name: translate('Co2.Sections.CARGO'),
          value: calculateCo2.sectors.site.categories.cargo.score,
          unit: translate('Projects.teCO2'),
          topic: 'cargo',
          type: 'co2',
          section: '',
        },
        {
          name: translate('Co2.Sections.BUILDING'),
          value: calculateCo2.sectors.site.categories.building.score,
          unit: translate('Projects.teCO2'),
          topic: 'building',
          type: 'co2',
          section: '',
        },
      ],
    },
  ];
}
